import axios from 'axios'

export const getConfigurationList = async (params) => {
  const response = await axios({
    method: 'GET',
    url: 'configurations/admin',
    params: {
      page: params.currentPage || 1,
      limit: params.pageSize,
      key: params.searchKey,
      isActive: params.isActive,
    },
  })

  return {
    result: response.data.data.data || [],
    total: response.data.data.total || 0,
    totalPages: response.data.data.totalPages || 0,
  }
}

export const fetchConfiguration = async (id) => {
  const response = await axios.get(`configurations/${id}`)
  
  return response.data.data
}

export const createConfiguration = async (data) => {
  const response = await axios.post('configurations', data)
  
  return response.data.data
}

export const updateConfiguration = async (data) => {
  const { id, key, createdAt, updatedAt, ...updateData } = data // Remove non-updateable fields
  const response = await axios.put(`configurations/${id}`, updateData)
  
  return response.data.data
}

export const deleteConfiguration = async (configurationId) => {
  const response = await axios.delete(`configurations/${configurationId}`)
  
  return response.data.data
}

export const toggleConfigurationStatus = async (id) => {
  const response = await axios.put(`configurations/${id}/toggle-status`)
  
  return response.data.data
}

export const fetchConfigurationByKey = async (key) => {
  const response = await axios({
    method: 'GET',
    url: 'configurations',
    params: {
      key,
      page: 1,
      limit: 100,
    },
  })

  const configurations = response?.data?.data?.data || []

  return configurations.find((configuration) => configuration.key === key) || null
}

export const updateConfigurationMetadataByKey = async ({ key, metadata }) => {
  const response = await axios.put(`configurations/key/${key}/metadata`, {
    metadata,
  })

  return response.data.data
}
